/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../Graphic.js";
import { unwrap as o, isSome as t } from "../../../core/maybe.js";
import r from "../../../geometry/Polygon.js";
import { addressToLocations as s } from "../../../rest/locator/addressToLocations.js";
import { locationToAddress as n } from "../../../rest/locator/locationToAddress.js";
import { suggestLocations as i } from "../../../rest/locator/suggestLocations.js";
import c from "../../../rest/support/AddressToLocationsParameters.js";
import a from "../../../rest/support/LocationToAddressParameters.js";
import l from "../../../rest/support/SuggestLocationsParameters.js";
import { createExtentFromGeometry as u, scaleExtent as m } from "./geometryUtils.js";
var f = "Single Line Input",
    d = 3e5;

function g(e, o) {
  return e.location ? j(e, o) : I(e, o);
}

function p(e, o) {
  if (o.localSearchDisabled) return null;
  var t = null == e ? void 0 : e.scale;
  return "number" == typeof t && t <= d ? e.get("extent.center") : null;
}

function y(e, t) {
  var r = e.source,
      s = e.spatialReference,
      n = e.view,
      c = e.suggestTerm,
      a = e.maxSuggestions,
      u = e.sourceIndex,
      m = new l(),
      f = r.apiKey,
      d = r.url,
      g = h(r, n),
      y = t && t.signal;
  if (!d) return Promise.resolve(null);
  f && (m.apiKey = f), r.categories && (m.categories = r.categories), s && (m.outSpatialReference = s);
  var x = p(n, r);
  x && (m.location = x);
  if (!c.trim()) return Promise.resolve(null);
  var _r$prefix = r.prefix,
      v = _r$prefix === void 0 ? "" : _r$prefix,
      _r$suffix = r.suffix,
      S = _r$suffix === void 0 ? "" : _r$suffix,
      w = "".concat(v).concat(c).concat(S);
  return m.text = w, g && (m.searchExtent = o(g)), m.maxSuggestions = a, r.countryCode && (m.countryCode = r.countryCode), i(d, m, {
    signal: y
  }).then(function (e) {
    return b(e, u);
  });
}

function x(e) {
  return !!e && /(?:geocode\-api\.arcgis\.com\/arcgis\/rest\/services\/world\/geocodeserver).*/gi.test(e);
}

function v(e) {
  return !!e && /(?:\/servers\/[\da-z\.-]+\/rest\/services\/world\/geocodeserver).*/gi.test(e);
}

function S(e) {
  return !!e && /(?:arcgis\.com\/arcgis\/rest\/services\/world\/geocodeserver).*/gi.test(e);
}

var w = "https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer";

function j(e, o) {
  var t = e.source,
      r = e.spatialReference,
      s = e.location,
      i = e.sourceIndex,
      c = e.view,
      l = t.apiKey,
      u = t.url,
      m = t.zoomScale,
      f = t.defaultZoomScale,
      d = c && c.scale,
      g = o && o.signal,
      p = new a();
  return p.location = s, l && (p.apiKey = l), r && (p.outSpatialReference = r), n(u, p, {
    signal: g
  }).then(function (e) {
    return L([e], {
      sourceIndex: i,
      scale: d,
      view: c,
      zoomScale: m,
      defaultZoomScale: f
    });
  });
}

function h(e, o) {
  var t = e.filter,
      r = e.withinViewEnabled,
      s = o && o.scale,
      n = o && o.extent,
      i = t && t.geometry;
  return u(i, o, s) || (r && n ? n : void 0);
}

function I(e, t) {
  var r = e.source,
      n = e.suggestResult,
      i = e.spatialReference,
      a = e.view,
      l = e.maxResults,
      u = e.sourceIndex,
      m = r && r.zoomScale,
      d = r && r.defaultZoomScale;
  if (!n.text.trim()) return Promise.resolve(null);
  var g = !n.key && r.prefix ? r.prefix : "",
      y = !n.key && r.suffix ? r.suffix : "",
      x = "".concat(g).concat(n.text).concat(y),
      v = new c(),
      S = r.apiKey,
      w = r.url,
      j = a && a.scale,
      I = h(r, a),
      $ = t && t.signal;
  if (S && (v.apiKey = S), !w) return Promise.resolve(null);
  r.categories && (v.categories = r.categories), r.locationType && (v.locationType = r.locationType), i && (v.outSpatialReference = i);
  var b = p(a, r);
  b && (v.location = b), v.maxLocations = l, I && (v.searchExtent = o(I)), r.countryCode && (v.countryCode = r.countryCode);
  var K = n.key,
      P = "".concat(K);
  return K && (v.magicKey = P), v.address = {}, v.address[r.singleLineFieldName || f] = x, r.outFields && (v.outFields = r.outFields), s(w, v, {
    signal: $
  }).then(function (e) {
    return L(e, {
      key: P,
      scale: j,
      sourceIndex: u,
      view: a,
      zoomScale: m,
      defaultZoomScale: d
    });
  });
}

function $(e, o) {
  return {
    text: e.text,
    key: e.magicKey,
    sourceIndex: o
  };
}

function b(e, o) {
  return e.map(function (e) {
    return $(e, o);
  });
}

function K(o, s) {
  var n = s.key,
      i = s.scale,
      c = s.sourceIndex,
      a = s.view,
      l = s.zoomScale,
      f = s.defaultZoomScale,
      d = o.attributes,
      g = o.extent,
      p = o.location,
      y = o.address,
      x = new e({
    geometry: p,
    attributes: d
  }),
      v = g || p,
      S = u(v, a, i),
      w = "number" == typeof l ? m(S, a, l) : "number" == typeof f && "point" === v.type ? m(S, a, f) : S,
      j = p ? "".concat(p.x, ",").concat(p.y) : "",
      h = y || j,
      I = x.clone();
  return t(w) && (I.geometry = r.fromExtent(w)), {
    extent: w,
    feature: x,
    target: I,
    key: n,
    name: h,
    sourceIndex: c
  };
}

function L(e, o) {
  return e.filter(Boolean).map(function (e) {
    return K(e, o);
  });
}

export { p as getLocation, g as getResults, y as getSuggestions, S as isArcGISWorldGeocoder, x as isMeteredArcGISWorldGeocoder, v as isProxiedArcGISWorldGeocoder, w as meteredArcGISLocatorUrl };